import clsx from 'clsx';
import { formatCompactNumber, KTSVG } from '../../../../../../_metronic/helpers';
import Avatar from '../../../../../modules/components/avatar/Avatar';
import TextWithLineBreaks from '../../../../../modules/components/text/TextWithLineBreaks';
import Time from '../../../../../modules/components/time/Time';

interface Props {
  data: {
    rating: number;
    title: string;
    name: string;
    publishDate: string;
    description?: string;
    location?: string;
    experienceDate?: string;
  };
  source?: React.ReactNode;
}

const maskName = (name: string): string => {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => {
      if (part.length <= 1) {
        return part;
      }

      return `${part.charAt(0)}${'*'.repeat(part.length - 1)}`;
    })
    .join(' ');
};

export default function ReviewCard({ data, source }: Props) {
  return (
    <div className='vstack border rounded p-4 gap-2'>
      {/* Header */}
      <div className='d-flex flex-column flex-sm-row justify-content-between gap-2'>
        {/* Left side: author + source */}
        <div className='d-flex gap-2 align-items-center'>
          <Avatar name={data.name} disableNameTooltip />
          <div className='vstack'>
            <span>{maskName(data.name)}</span>
            <span className='text-muted small'>
              <Time date={new Date(data.publishDate)} format='MMM d, yyyy' />
              {data?.location && (
                <>
                  &ensp;|&ensp;
                  {data.location}
                </>
              )}
              {/* {source && (
                <>
                  &ensp;|&ensp;
                  {source}
                </>
              )} */}
            </span>
          </div>
        </div>
        {/* Right side: rating */}
        <div className='rating'>
          {Array.from(Array(5), (_, index) => (
            <div className={clsx('rating-label', index < data.rating && 'checked')} key={index}>
              <KTSVG
                path='/media/icons/duotune/general/gen029.svg'
                className='svg-icon svg-icon-1'
              />
            </div>
          ))}
        </div>
      </div>

      {data?.title && <span className='fs-6'>{data?.title}</span>}

      {data?.description && (
        <TextWithLineBreaks text={data?.description} className='fs-7 text-muted' />
      )}
    </div>
  );
}
